import { AppForm, Maintenance } from '@workspace/core-ts/components';
import { sentryInit } from '@workspace/utils';
import ReactDOM from 'react-dom/client';
import livraisonFormConfig from '@/config/form-config';
import { LivraisonStateResolver } from './config/livraison-state-resolver';
import initialState from './initial-state';
import steps from './steps';
import './styles/global.css';

sentryInit();

const isMaintenance = window.location.pathname === '/maintenance';

ReactDOM.createRoot(document.getElementById('root')!).render(
  isMaintenance ? (
    <Maintenance />
  ) : (
    <AppForm
      initialFormState={initialState}
      origin="livraison"
      steps={steps}
      config={livraisonFormConfig}
      stateResolver={new LivraisonStateResolver()}
    />
  ),
);
